import { combineReducers } from 'redux';

import { documentAnalyticsReducer } from '../analytics/store/reducer';
import { chatbotReducer } from '../chatbot/store/reducer';
import { myDocumentsReducer } from '../my-documents/store/reducer';
import { documentReportingReducer } from '../reporting/store/reducer';
import { searchDocumentsReducer } from '../search/store/reducer';

export const documentReducer = combineReducers({
    myDocuments: myDocumentsReducer,
    search: searchDocumentsReducer,
    analytics: documentAnalyticsReducer,
    reporting: documentReportingReducer,
    chatbot: chatbotReducer
});
